<template>
  <div class="ovop-ranking">
    <div class="head">{{title}}</div>
    <div class="body">
      <div v-if="ovopArray.length == 0">该地区暂无商品！</div>
      <div v-for="(item, index) in ovopArray" :key="index" @click="click(item.id)">
        <div class="index">
          <span>{{index + 1}}</span>
        </div>
        <div class="image">
          <img :src="util.getImageUrl(util.getHead(util.string2Array(item.images)), '120x120')" alt />
        </div>
        <div class="intro">
          <div class="name">{{item.name}}</div>
          <div class="place">{{item.place}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OvopRanking",
  props: ["title", "ovopArray"],
  methods: {
    click(id) {
      window.open(`/ovop/detail/${id}`);
    }
  }
};
</script>

<style lang="less" scoped>
.ovop-ranking {
  width: 360px;
  height: 720px;
  display: inline-block;
  vertical-align: top;

  position: relative;
  overflow: hidden;
  .head {
    font-size: 20px;
    font-weight: 500;
    color: rgba(27, 153, 79, 1);
    text-align: center;

    height: 55px;
    line-height: 55px;

    border-bottom: 1px solid #eee;
  }

  // .body::-webkit-scrollbar {
  //   display: none;
  // }

  .body {
    position: absolute;
    left: 0;
    top: 55px;
    right: -17px;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: scroll;

    .index {
      width: 30px;
      font-size: 14px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);

      display: inline-block;
      vertical-align: top;

      text-align: right;

      //   line-height: 100%;

      margin-top: 40px;
    }

    .image {
      width: 70px;
      display: inline-block;
      padding: 15px 30px;
      vertical-align: top;
      cursor: pointer;

      img {
        width: 100%;
        border-radius: 5px;
      }
    }

    .intro {
      width: 200px;
      display: inline-block;
      vertical-align: top;
      cursor: pointer;

      .name {
        font-size: 14px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);

        margin-top: 20px;
      }

      .place {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        font-size: 12px;
        font-weight: 400;
        color: rgba(109, 114, 120, 1);
        line-height: 17px;
      }
    }
  }
}
</style>